import {Injectable} from "@angular/core";
import {AuthService} from "../auth/auth.service";
import {Member} from "../member/member";
import { ShareService } from "../share/share.service";

declare var dataLayer: any;

@Injectable()
export class GtmService {
  breadCrumbs = [
    //{url: '/', breadcrumb: 'Home'},

    {url: '/heyground/about', breadcrumb: 'Home > Heyground > About', title: 'About'},
    {url: '/heyground/partners', breadcrumb: 'Home > Heyground > Partners', title: 'Partners'},
    {url: '/heyground/team', breadcrumb: 'Home > Heyground > Team', title: 'Team'},
    {url: '/heyground/location', breadcrumb: 'Home > Heyground > Location', title: 'Location'},
    //{url: '/heyground/press', breadcrumb: 'Home > Heyground > Press'},

    {url: '/space/design', breadcrumb: 'Home > Space > Design', title: 'Design'},
    {url: '/space/floor-info', breadcrumb: 'Home > Space > Floor Info', title: 'Floor Info'},
    {url: '/space/tour', breadcrumb: 'Home > Space > Tour', title: 'Tour'},
    {url: '/space/book-space', breadcrumb: 'Home > Space > Book Space', title: 'Book Space'},

    {url: '/membership/plan', breadcrumb: 'Home > Membership > Plan', title: 'Plan'},
    {url: '/membership/benefits', breadcrumb: 'Home > Membership > Benefits', title: 'Benefits'},
    {url: '/membership/apply', breadcrumb: 'Home > Membership > Apply', title: 'Apply'},
    {url: '/membership/faq', breadcrumb: 'Home > Membership > FAQ', title: 'FAQ'},

    //{url: '/community/members', breadcrumb: 'Home > Community > Members'},
    {url: '/community/events', breadcrumb: 'Home > Community > Events', title: 'Events'},
    //{url: '/community/blog', breadcrumb: 'Home > Community > Blog'},
  ];

  me: Member;

  gender = {
    'MALE': '남자',
    'FEMALE': '여자',
    'ETC': '기타',
  };

  constructor(private authService: AuthService, private shareService: ShareService) {
  }

  public pageView(url: string) {
    let breadCrumb = this.breadCrumbs.find(breadCrumb => url.startsWith(breadCrumb.url));
    if (!breadCrumb) return;

    const page = {
      'path': url,
      'title': breadCrumb.title,
      'breadcrumb': breadCrumb.breadcrumb
    };

    this.pageViewWithPage(page);
  }

  public pageViewWithPage(page) {
    if (this.authService.canActivate()) {
      if (!this.authService.getMe()) {
        this.shareService.awaitMe().subscribe(me => {
          this.authService.me = me;
          this.me = me;
          
          this.pageViewPush(page, this.getUser());
        });
      } else {
        this.me = this.authService.getMe();
        this.pageViewPush(page, this.getUser());
      }
    } else {
      this.pageViewPush(page, null);
    }
  }


  private pageViewPush(page, user) {
    if (user) {
      dataLayer.push({
        'event': 'pageview',
        'page': page,
        'user': user
      });
    } else {
      dataLayer.push({
        'event': 'pageview',
        'page': page
      });
    }
  }

  private getUser() {
    return {
      'userid': this.me.id,
      'team': this.me.team.name,
      'job': this.me.work,
    }
  }

  public loginEvent() {
    if (!this.authService.canActivate()) return;

    this.shareService.awaitMe().subscribe(me => {
      this.authService.me = me;
      this.me = me;
      dataLayer.push({
        'event': 'login',
        'user': this.getUser()
      });
    });
  }

  public newPostEvent(post) {
    dataLayer.push({
      'event': 'new_post',
      'page': {
        'post': post
      }
    });
  }

  public newCommentEvent(post) {
    dataLayer.push({
      'event': 'new_comment',
      'page': {
        'post': post
      }
    });
  }

  public likeEvent(post) {
    dataLayer.push({
      'event': 'like_post',
      'page': {
        'post': post
      }
    });
  }

  public sendMessageEvent() {
    dataLayer.push({
      'event': 'send_message'
    });
  }

  public viewProfileEvent() {
    dataLayer.push({
      'event': 'view_memberprofile'
    });
  }

  public bookMeetingRoomEvent(reservation) {
    dataLayer.push({
      'event': 'book_meetingroom',
      'meetingroom': reservation
    });
  }

  public cancelMeetingRoomEvent(reservation) {
    dataLayer.push({
      'event': 'cancel_meetingroom',
      'meetingroom': reservation
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/service/gtm/gtm.service.ts